import { render, staticRenderFns } from "./ModalEditNotifications.vue?vue&type=template&id=3e826dab&"
import script from "./ModalEditNotifications.vue?vue&type=script&lang=js&"
export * from "./ModalEditNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports